<!-- eslint-disable vue/multi-word-component-names -->
<script>
import AppPageContainer from '@/components/app/PageContainer.vue';
import AppPagination from '@/components/app/Pagination.vue';
import FilterModal from '@/components/amar/airAmbulance/workStart/filter.modal.vue';
// ==============================================
import SharedMixin from '../../../../../Mixins/Shared';
import SharedHelper from '@/Helpers/Shared';
import CityMixin from '@/Mixins/BaseInformation/CityMixin';
import WorkStartHelper from '@/Helpers/Report/Amar/airAmbulance/workStart.helper';
import AirAmbulanceMixin from '@/Mixins/Report/airAmbulance.mixin';
import PhoneMixin from '@/Mixins/BaseInformation/PhoneMixin';
export default {
  inject: ['load'],
  mixins: [SharedHelper, SharedMixin, WorkStartHelper, AirAmbulanceMixin, CityMixin, PhoneMixin],
  components: {
    AppPageContainer,
    AppPagination,
    FilterModal,
  },
};
</script>
<template>
  <app-page-container title="گزارش شروع به کار">
    <template v-slot:header>
      <v-col cols="4" class="mr-n11">
        <v-text-field outlined rounded placeholder="جستجو..." append-icon="mdi-magnify" dense v-model="searchTitle"
          class="mt-3"></v-text-field>
      </v-col>
      <v-col cols="1" class="mr-n3">
        <v-btn class="mx-2 mt-3" fab dark small color="darkColor" elevation="0" @click="openFilterModal()">
          <v-icon dark>mdi-filter mdi-18px</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="1" class="mr-n3 mt-6" v-if="isSearch">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon light v-bind="attrs" v-on="on" @click="clearFilter()">
              mdi-filter-remove mdi-18px
            </v-icon>
          </template>
          <span>حذف فیلتر ها</span>
        </v-tooltip>
      </v-col>
      <v-spacer></v-spacer>
    </template>
    <template v-slot:body>
      <v-row no-gutters class="background-main mx-2">
        <v-col cols="12">
          <v-card elevation="0" class="card-width body-card pa-0">
            <template>
              <v-data-table fixed-header hide-default-footer :headers="tableHeaders" :items="workStartPaginateDataList"
                :page.sync="page" :items-per-page="missionReportDataTableInfo?.length" height="68dvh"
                :search="searchTitle">
                <template v-slot:[`item.action`]="{ item }">
                  <v-row>
                    <v-col>
                      <v-btn dark icon rounded small :to="`/amar/report/air_ambulance/work_start/${item?.id}`">
                        <v-icon dark color="iconColor">mdi-information mdi-20px</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </template>
                <template v-slot:no-data>
                  <span>اطلاعاتی جهت نمایش وجود ندارد</span>
                </template>
              </v-data-table>
              <app-pagination :total-pages="pagination.totalItems" v-model="pagination" />
            </template>
          </v-card>
        </v-col>
      </v-row>
    </template>
    <template v-slot:append>
      <filterModal v-if="isFilterModalOpen" :all-cities-list="allCitys" :all-phones-list="allPhones"
        :default-fields="filterData" @set-filter="setFilter" @close-modal="closeFilterModal" />
    </template>
  </app-page-container>
</template>
<style lang="css">
.tt tbody tr:nth-of-type(even) {
  background-color: var(--background-color) !important;
}
</style>
